module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Bold.83f3f86d.woff";